import { render, staticRenderFns } from "./placeorder.vue?vue&type=template&id=56a882ae&scoped=true"
import script from "./placeorder.vue?vue&type=script&lang=js"
export * from "./placeorder.vue?vue&type=script&lang=js"
import style0 from "./placeorder.vue?vue&type=style&index=0&id=56a882ae&prod&lang=scss"
import style1 from "./placeorder.vue?vue&type=style&index=1&id=56a882ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a882ae",
  null
  
)

export default component.exports